import client from '../core/client';

export default data => client.post('/v1/form/', data);
